// Count distinct connected neighbours, irrespective of edge direction or
// how many source records describe the same pair.
export function nodeDegrees(data) {
  const neighbours = new Map(data.nodes.map(node => [node.id, new Set()]));
  const endpoint = value => value && typeof value === 'object' ? value.id : value;
  data.links.forEach(link => {
    const source = endpoint(link.source);
    const target = endpoint(link.target);
    if (source === target || !neighbours.has(source) || !neighbours.has(target)) return;
    neighbours.get(source).add(target);
    neighbours.get(target).add(source);
  });
  return new Map([...neighbours].map(([id, connected]) => [id, connected.size]));
}

export function degreeRadius(degree) {
  return Math.min(18, 5 + 2 * Math.sqrt(Math.max(0, degree)));
}
